import React, { useMemo } from "react";
import { Comments } from "../..";
import { useDealParamsHooks } from "../../../hooks/deal-hooks/use-deal-params-hooks";
import "./DealDrawer.styles.scss";

interface DealDrawerProps {}

export const DealDrawer: React.FC<DealDrawerProps> = () => {
  const { barContent } = useDealParamsHooks();

  const content = useMemo(() => {
    switch (barContent) {
      // case "activity-log":
      //   return <ActivityLog />;
      case "comments":
        return <Comments />;
      default:
        return <div />;
    }
  }, [barContent]);

  return (
    <div
      className={`deal-drawer flex-col-st-fc deal-drawer${
        barContent ? "--active" : ""
      }`}>
      {content}
    </div>
  );
};
